module.exports = __webpack_public_path__ + "static/media/14.0f1f0e7e.jpg";